<template>
  <ion-page>
    <MyHeader title="マネーにっき" icon="/assets/icon/icon.png" />
    <ion-content :fullscreen="true">
      <div class="ion-padding container">
        <ion-text>
          <h3>マネーにっき とは</h3>
          <p>
            「マネーにっき」は、誰でも気軽に始められる・続けられる家計簿サービスです。
          </p>
          <p>
            1日の出費の内容と金額を1ページにまとめて付けるだけなので、入力の手間は最低限。<br />
            どんなに高機能で便利な家計簿も、続かなければ意味がありません。<br />
            まずは毎日の出費を「見える化」しましょう！
          </p>
          <h4>注意</h4>
          <p>
            ※このサービスはα版です。ご利用の際は不具合の可能性があること、今後予告なく仕様やサービス内容の変更・終了の可能性があることをご了承ください。<br />
          </p>
          <!-- <div class="ion-text-center">
            <img src="/img/mainvisual.jpg" class="image" />
          </div> -->
          <h3>使い方</h3>
          <ol>
            <li>
              <router-link to="/calendar/">カレンダー</router-link
              >で日付を選択します
            </li>
            <li>項目名と金額を一気に入力して保存します</li>
            <li>毎日の出費と、月の合計金額が表示されます</li>
            <li>
              <router-link to="/settings/">設定</router-link
              >の<b>テンプレート編集</b>で、よく使う項目をあらかじめセットしておくことができます
            </li>
          </ol>
          <div v-show="user === null" class="ion-padding">
            <FirestoreAuthModal />
          </div>
          <h3>スクリーンショット</h3>
          <ion-slides :pager="true">
            <ion-slide>
              <div>
                <picture>
                  <source
                    media="(min-width: 769px)"
                    srcset="/img/screenshot1_pc.png"
                  />
                  <img
                    src="/img/screenshot1_sp.png"
                    alt="カレンダー"
                    class="image"
                  />
                </picture>
                <div class="slide-text">カレンダー</div>
              </div>
            </ion-slide>
            <ion-slide>
              <div>
                <picture>
                  <source
                    media="(min-width: 769px)"
                    srcset="/img/screenshot2_pc.png"
                  />
                  <img
                    src="/img/screenshot2_sp.png"
                    alt="日付別ページ"
                    class="image"
                  />
                </picture>
                <div class="slide-text">日付別ページ</div>
              </div>
            </ion-slide>
          </ion-slides>
          <p></p>

          <h3>お問い合わせ</h3>
          <p>
            <a href="https://twitter.com/ykoizumi0903" target="_blank"
              >@ykoizumi0903</a
            >
            までお願いします。<br />
            <br />
            使用技術は
            <a
              href="https://zenn.dev/ytr0903/articles/5b3f1d4d7eedd9"
              target="_blank"
              >Zenn.dev</a
            >
            にて公開しています。
          </p>
          <!-- <h4>今後の開発予定</h4>
          <ul>
            <li>項目の並び替え機能</li>
            <li>項目別の支出額の分析ページ</li>
            <li>匿名アカウントでの一時利用</li>
            <li>Androidアプリ</li>
            <li>テンプレートの複数登録</li>
            <li>iOSアプリ</li>
          </ul> -->
        </ion-text>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { IonPage, IonContent, IonText, IonSlides, IonSlide } from '@ionic/vue'
import { defineComponent } from 'vue'
import MyHeader from '@/components/layouts/MyHeader.vue'
import { useFirebaseAuthModule } from '@/provider/FirebaseAuthModule'
import FirestoreAuthModal from '@/components/organisms/settings/FirestoreAuthModal.vue'

export default defineComponent({
  components: {
    IonContent,
    IonPage,
    IonText,
    IonSlides,
    IonSlide,
    MyHeader,
    FirestoreAuthModal,
  },
  setup() {
    const { user } = useFirebaseAuthModule()
    return {
      user,
    }
  },
})
</script>

<style lang="scss" scoped>
.container {
  min-height: 100%;
  background-image: url('/img/mainvisual.jpg');
  background-color: rgba(#fff, 0.8);
  background-size: cover;
  background-position: center;
  background-blend-mode: lighten;
}

.swiper-container {
  --bullet-background: #333;
}
.image {
  width: 75%;
  max-width: 640px;
}

.slide-text {
  font-size: 14px;
  padding-bottom: 32px;
}

h3:not(:first-child) {
  margin-top: 2.4rem;
}
</style>
